import React, {Fragment} from 'react'

import getCurrencySymbol from '../../../../utilities/currency/getCurrencySymbol'
import formatPrice from '../../../../utilities/currency/formatPrice'

import _ from 'lodash'
import yn from 'yn'

const BkFlowStructuredSidebarRoomCard = props => {
  const {
    activeCurrencyData,
    activeEnhancementData,
    activeGuestData,
    activeRoomData,
    displayedPriceFrequency,
    handleRemoveEnhancement,
    hotelLabels,
    isTaxInclusiveProperty,
    roomKey,
    totalNights,
  } = props

  let activeRoomTypeCode = null
  let activeRoomName = null
  let activeRoomPrice = null
  let activeRoomCurrencyCode = null
  let activeRoomCurrencySymbol = null
  let activeRoomEnhancements = []

  if (
    activeRoomData &&
    activeRoomData[Number(roomKey)]
  ) {
    const currentRoom = activeRoomData[Number(roomKey)]

    if (
      currentRoom &&
      currentRoom[1] &&
      currentRoom[1][0] &&
      currentRoom[1][0].roomTypeCode
    ) {
      activeRoomTypeCode = _.get(currentRoom, '[1][0].roomTypeCode')
    }

    if (
      currentRoom &&
      currentRoom[1] &&
      _.get(currentRoom[1], '[0].rates[0].total.currencyCode')
    ) {
      activeRoomCurrencyCode = currentRoom[1][0].rates[0].total.currencyCode
      activeRoomCurrencySymbol = getCurrencySymbol(activeRoomCurrencyCode)

      if (
        yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
        activeCurrencyData &&
        activeCurrencyData.exchangeRate &&
        activeCurrencyData.currencyCode
      ) {
        activeRoomCurrencyCode = activeCurrencyData.currencyCode
        activeRoomCurrencySymbol = getCurrencySymbol(activeRoomCurrencyCode)
      }
    }

    if (
      currentRoom &&
      currentRoom[1] &&
      _.get(currentRoom[1], '[0].rates[0].total.amountBeforeTax')
    ) {
      if (displayedPriceFrequency === 'per stay') {
        if (isTaxInclusiveProperty) {
          activeRoomPrice = formatPrice(currentRoom[1][0].rates[0].total.amountAfterTax, 2)
        } else {
          activeRoomPrice = formatPrice(currentRoom[1][0].rates[0].total.amountBeforeTax, 2)
        }
      } else {
        if (isTaxInclusiveProperty) {
          activeRoomPrice = formatPrice(currentRoom[1][0].rates[0].total.amountAfterTax / totalNights, 2)
        } else {
          activeRoomPrice = formatPrice(currentRoom[1][0].rates[0].total.amountBeforeTax / totalNights, 2)
        }
      }

      if (
        yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
        activeCurrencyData &&
        activeCurrencyData.exchangeRate &&
        activeCurrencyData.currencyCode
      ) {
        if (displayedPriceFrequency === 'per stay') {
          if (isTaxInclusiveProperty) {
            activeRoomPrice = formatPrice(currentRoom[1][0].rates[0].total.amountAfterTax * activeCurrencyData.exchangeRate, 2)
          } else {
            activeRoomPrice = formatPrice(currentRoom[1][0].rates[0].total.amountBeforeTax * activeCurrencyData.exchangeRate, 2)
          }
        } else {
          if (isTaxInclusiveProperty) {
            activeRoomPrice = formatPrice(currentRoom[1][0].rates[0].total.amountAfterTax / totalNights * activeCurrencyData.exchangeRate, 2)
          } else {
            activeRoomPrice = formatPrice(currentRoom[1][0].rates[0].total.amountBeforeTax / totalNights * activeCurrencyData.exchangeRate, 2)
          }
        }
      }
    }

    if (
      currentRoom &&
      currentRoom[0] &&
      _.get(currentRoom[0], '[0].roomDescription.name')
    ) {
      activeRoomName = currentRoom[0][0].roomDescription.name
    }
  }

  if (!_.isEmpty(activeEnhancementData)) {
    for (let enhancementKey in activeEnhancementData) {

      if (
        Number(activeEnhancementData[enhancementKey].roomGroup) === Number(roomKey) &&
        String(activeEnhancementData[enhancementKey].roomType) === String(activeRoomTypeCode)
      ) {
        const currentEnhancement = activeEnhancementData[enhancementKey]

        let keyedDetails = {}

        // Loop and uniquely key enhancement details
        if (!_.isEmpty(currentEnhancement.enhancementApiData.serviceDetails.comments)) {
          const currentDetails = currentEnhancement.enhancementApiData.serviceDetails.comments

          for (let detailKey in currentDetails) {
            keyedDetails[currentDetails[detailKey].name.toLowerCase()] = currentDetails[detailKey]
          }
        }

        let activeEnhancementPrice = null

        if (
          currentEnhancement.enhancementApiData &&
          currentEnhancement.enhancementApiData.price &&
          _.get(currentEnhancement.enhancementApiData.price, '[0].base.amountBeforeTax')
        ) {
          activeEnhancementPrice = formatPrice(currentEnhancement.enhancementApiData.price[0].base.amountBeforeTax, 2)

          if (
            yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
            activeCurrencyData &&
            activeCurrencyData.exchangeRate &&
            activeCurrencyData.currencyCode
          ) {
            activeEnhancementPrice = formatPrice(currentEnhancement.enhancementApiData.price[0].base.amountBeforeTax * activeCurrencyData.exchangeRate, 2)
          }
        }

        if (
          keyedDetails.title &&
          keyedDetails.title.text
        ) {
          activeRoomEnhancements.push(
            <div
              className="property-room-enhancement"
              key={ keyedDetails.title.text + '-' + roomKey }
            >
              <p className="property-room-enhancement-title">
                { keyedDetails.title.text }
                <i
                  onClick={() => handleRemoveEnhancement(activeEnhancementData, enhancementKey)}
                  className="material-icons"
                  tabIndex={0}
                >
                  remove_circle_outline
                </i>
              </p>

              { activeEnhancementPrice &&
                <p className="property-room-enhancement-price">
                  {activeRoomCurrencySymbol &&
                    <span className="currency-symbol">{activeRoomCurrencySymbol}</span>
                  }

                  {activeEnhancementPrice}

                  {activeRoomCurrencyCode &&
                    <span className="currency-code">&nbsp;{activeRoomCurrencyCode}</span>
                  }
                </p>
              }
            </div>
          )
        }
      }
    }
  }

  return (
    <div className="bk-flow-structured-sidebar__row property-room-card">
      <h6>
        {hotelLabels.room ? hotelLabels.room : 'room'}&nbsp;
        {Number(roomKey) + 1}
        {activeRoomPrice &&
          <span className="property-room-card-price">
            {activeRoomCurrencySymbol &&
              <span className="currency-symbol">{activeRoomCurrencySymbol}</span>
            }

            { activeRoomPrice }

            {activeRoomCurrencyCode &&
              <span className="currency-code">&nbsp;{activeRoomCurrencyCode}</span>
            }
          </span>
        }
      </h6>

      { activeGuestData &&
        activeGuestData.adults &&
        <p className="u-remove-margin">
          <span className="property-room-card-adults">
            {activeGuestData.adults}&nbsp;
            {(Number(activeGuestData.adults) === 0 || Number(activeGuestData.adults) > 1) ?
              hotelLabels.adults ? hotelLabels.adults : 'Adults'
            :
              hotelLabels.adult ? hotelLabels.adult : 'Adult'
            }
          </span>

          { activeGuestData &&
            Number(activeGuestData.children) > 0 &&
            <Fragment>
              <span className="property-room-card-divide">|</span>
              <span className="property-room-card-children">
                {activeGuestData.children}&nbsp;
                {(Number(activeGuestData.children) === 0 || Number(activeGuestData.children) > 1) ?
                  hotelLabels.children ? hotelLabels.children : 'Children'
                :
                  hotelLabels.child ? hotelLabels.child : 'Child'
                }
              </span>
            </Fragment>
          }
        </p>
      }

      { activeRoomName &&
	      <p className="u-remove-margin">{ activeRoomName }</p>
      }

      { activeRoomEnhancements &&
      !_.isEmpty(activeRoomEnhancements) &&
        <div className="bk-flow-structured-sidebar__enhancements">
          {activeRoomEnhancements}
        </div>
      }
    </div>
  )
}

export default BkFlowStructuredSidebarRoomCard



// WEBPACK FOOTER //
// ./src/components/structure/sidebar/elements/BkFlowStructuredSidebarRoomCard.js